import { QueryClient } from 'react-query';
import { queryKeys } from '../services/query-key/query-keys';

export async function invalidateProductsQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.catalogProducts()),
    queryClient.invalidateQueries(queryKeys.productPage()),
    queryClient.invalidateQueries(queryKeys.creditTypes()),
  ]);
}

export async function invalidateCreditTypesQueries(queryClient: QueryClient) {
  await queryClient.invalidateQueries(queryKeys.creditTypes());
}

// Customer-related queries
export async function invalidateCustomersQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.customer()),
    queryClient.invalidateQueries(queryKeys.customersOverviews()),
    queryClient.invalidateQueries(queryKeys.customersOverviewsNew()),
    queryClient.invalidateQueries(queryKeys.customersNames()),
    queryClient.invalidateQueries(queryKeys.customersCountByStatus()),
    queryClient.invalidateQueries(queryKeys.customerContractsOverviewPage()),
  ]);
}

// Invoice-related queries
export async function invalidateInvoicesQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.invoices()),
    queryClient.invalidateQueries(queryKeys.invoicesOverviewsNew()),
    queryClient.invalidateQueries(queryKeys.invoicesHighlightsStatistics()),
    queryClient.invalidateQueries(queryKeys.invoiceStatistics()),
    queryClient.invalidateQueries(queryKeys.invoiceSummary()),
    queryClient.invalidateQueries(queryKeys.billingCycleInvoices()),
    queryClient.invalidateQueries(queryKeys.customerInvoicePageData()),
    queryClient.invalidateQueries(queryKeys.customerContractsOverviewPage()),
    queryClient.invalidateQueries(queryKeys.dynamicInvoice()),
    queryClient.invalidateQueries(queryKeys.creditLedgerOverview()),
    queryClient.invalidateQueries(queryKeys.creditPools()),
  ]);
}

// Contract-related queries
export async function invalidateContractsQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.contracts()),
    queryClient.invalidateQueries(queryKeys.contractsOverview()),
    queryClient.invalidateQueries(queryKeys.contractsReport()),
  ]);
}

// Billing & revenue reports
export async function invalidateBillingRevenueQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.billingCyclesOverview()),
    queryClient.invalidateQueries(queryKeys.recurringRevenueReport()),
    queryClient.invalidateQueries(queryKeys.commitmentReport()),
    queryClient.invalidateQueries(queryKeys.homePageAccountSummary()),
  ]);
}

// Plan-related queries
export async function invalidatePlansQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.plans()),
    queryClient.invalidateQueries(queryKeys.plansOverviews()),
    queryClient.invalidateQueries(queryKeys.recentlyUsedPlans()),
  ]);
}

// Meter/Product measurement queries
export async function invalidateMetersQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.meters()),
    queryClient.invalidateQueries(queryKeys.measurementsStats()),
  ]);
}

// Payment-related queries
export async function invalidatePaymentsQueries(queryClient: QueryClient) {
  await Promise.all([
    queryClient.invalidateQueries(queryKeys.paymentsNew()),
    queryClient.invalidateQueries(queryKeys.paymentsOverview()),
  ]);
}
